/**
 * @fileoverview Types for Airtable integration
 *
 * Including:
 * - Types for Airtable API responses
 * - Types for request data sent to Airtable API
 *
 */

/**
 * Airtable scopes: what endpoints, actions, features the integration has access to
 * https://airtable.com/developers/web/api/scopes
 */
export enum AirtableIntegrationScopes {
  BasesRead = 'schema.bases:read',
  BasesWrite = 'schema.bases:write',
  RecordsRead = 'data.records:read',
  RecordsWrite = 'data.records:write',
  WebhookManage = 'webhook:manage',
}

export const AirtableAuthScopesToHumanReadableMap: { [key: string]: string } = {
  [AirtableIntegrationScopes.BasesRead]: 'Bases Read',
  [AirtableIntegrationScopes.BasesWrite]: 'Bases Write',
  [AirtableIntegrationScopes.RecordsRead]: 'Records Read',
  [AirtableIntegrationScopes.RecordsWrite]: 'Records Write',
  [AirtableIntegrationScopes.WebhookManage]: 'Webhook Manage',
}

/**
 * Airtable authorization error codes
 * https://airtable.com/developers/web/api/oauth-reference#authorization-error-codes
 */
export const AIRTABLE_AUTHENTICATION_ERROR_CODES = {
  INVALID_REQUEST: 'invalid_request',
  ACCESS_DENIED: 'access_denied',
  INVALID_SCOPE: 'invalid_scope',
  SERVER_ERROR: 'server_error',
  TEMPORARILY_UNAVAILABLE: 'temporarily_unavailable',
}

/**
 * Spec for creating Airtable webhooks:
 * Only generate payloads that contain changes affecting objects of these types
 * https://airtable.com/developers/web/api/model/webhooks-specification#filters-datatypes
 */
export const AIRTABLE_WEBHOOK_SPEC_DATATYPES = {
  TABLE_DATA: 'tableData',
  TABLE_FIELDS: 'tableFields',
  TABLE_METADATA: 'tableMetadata',
}
